import { useId } from 'react';

import styles from './animations.module.css';

interface ConnectionRestoredProps {
  width?: string;
  height?: string;
  className?: string;
}

const ConnectionRestored = ({
  width = '150px',
  height = 'auto',
  className = '',
}: ConnectionRestoredProps) => {
  const clipId = `earth-clip-${useId()}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="8 32 84 36"
      fill="none"
      shapeRendering="geometricPrecision"
      style={{ width, height }}
      className={className}
    >
      <g className={styles.animateDrift}>
        {/* Solid connected backbone */}
        <path
          d="M 35 50 L 67 50"
          stroke="#10b981"
          strokeWidth="2.5"
          strokeLinecap="round"
          opacity="0.8"
        />

        {/* Left node: earth & orbit */}
        <circle
          className={styles.spinLeft}
          cx="26"
          cy="50"
          r="16"
          stroke="#10b981"
          strokeWidth="1.2"
          strokeDasharray="3 3"
          opacity="0.6"
        />
        <g>
          <circle cx="26" cy="50" r="10" fill="#0284c7" />
          <clipPath id={clipId}>
            <circle cx="26" cy="50" r="10" />
          </clipPath>
          <g clipPath={`url(#${clipId})`}>
            <path
              d="M 18 46 Q 22 40 28 44 Q 32 46 35 50 Q 28 54 22 52 Z"
              fill="#22c55e"
            />
            <path
              d="M 23 56 Q 27 58 31 55 Q 34 52 35 58 Q 28 62 21 58 Z"
              fill="#22c55e"
            />
          </g>
          <circle
            cx="26"
            cy="50"
            r="10"
            stroke="#38bdf8"
            strokeWidth="0.75"
            opacity="0.5"
          />
        </g>

        {/* Right node: moon & orbit */}
        <circle
          className={styles.spinRight}
          cx="74"
          cy="50"
          r="15"
          stroke="#10b981"
          strokeWidth="1.2"
          strokeDasharray="3 3"
          opacity="0.4"
        />
        <g>
          <circle cx="74" cy="50" r="7" fill="#cbd5e1" />
          <circle cx="72" cy="47" r="1.2" fill="#94a3b8" opacity="0.6" />
          <circle cx="76" cy="52" r="1" fill="#94a3b8" opacity="0.6" />
          <circle cx="76" cy="46" r="0.6" fill="#94a3b8" opacity="0.6" />
        </g>

        {/* Success pulse in the center */}
        <circle
          className={styles.successGlow}
          cx="50"
          cy="50"
          r="6"
          stroke="#10b981"
          strokeWidth="1.5"
        />

        {/* Moving data packets (offset intervals) */}
        <circle
          className={styles.dataStream1}
          cx="0"
          cy="50"
          r="1.8"
          fill="#34d399"
        />
        <circle
          className={styles.dataStream2}
          cx="0"
          cy="50"
          r="1.8"
          fill="#34d399"
        />
      </g>
    </svg>
  );
};

export default ConnectionRestored;
